
import './_summary.scss';

export interface ISummaryItemProps {
    title: string;
    value: string | number | null;
    style?: string;
    className?: string;
    textColor?: string;
    onClick?: any;
    noValue?: boolean;
}

export default function SummaryItem(props: ISummaryItemProps) {
    return (
        <>
            <div
                onClick={() => props.onClick && props.onClick()}
                className={`summary_item ${
                    props.className ? props.className : ""
                } ${props.noValue ? "no_value" : ""}`}
            >
                <div className="summary_item_title">{props.title}</div>
                {props.noValue ? null : (
                    <h2 className={`summary_item_value ${props.textColor}`}>
                        {props.value}
                    </h2>
                )}
            </div>
        </>
    );
}
